import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
	UserOutlined,
	MailOutlined,
	WhatsAppOutlined,
	ArrowDownOutlined,
	DownOutlined
} from '@ant-design/icons';
import { Avatar, Button, Modal, Typography, Row } from 'antd';
import { isMobile } from 'react-device-detect';
import axios from 'axios';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import env from '../../../../../environment';
import { commonNotifications } from 'mortgage-documents/src/document-boxes/CommonItems';

const { Text } = Typography;

const AnalystInformation = ({ name, phone, email, image, valuesDataAgent, dataValues }) => {
	const { t } = useTranslation();
	const [showModalAvatar, setShowModalAvatar] = useState(false);
	const params = useParams();
	const userToken = useSelector((state) => state.auth.token);

	const sendEmail = () => {
		axios
			.get(`${env.api.url}/v1/hadmin/sales-agents/contact-agent-b2b/${params.operationId}`, {
				headers: { Authorization: `Bearer ${userToken}` }
			})
			.then(() => {
				commonNotifications('success', t('form.message'), t('form.messageSuccess'), true);
			})
			.catch(() => {
				commonNotifications(
					'error',
					t('form.messageError'),
					t('promoterLoan.ModalTextError'),
					true
				);
			});
	};

	return (
		<>
			{!isMobile && (
				<div style={{ textAlign: 'center' }}>
					<div
						style={{
							fontSize: 14,
							fontWeight: 600,
							color: '#262626',
							marginBottom: 8
						}}>
						{t('details.commercial')}
					</div>

					{image !== undefined && image !== null ? (
						<img src={image} alt="imageAgent" height={58} />
					) : (
						<Avatar size={58} icon={<UserOutlined />} />
					)}

					<div
						style={{
							fontSize: 12,
							fontWeight: 500,
							color: '#262626',
							lineHeight: '16px',
							marginTop: 12
						}}>
						{name}
					</div>
					<div
						style={{
							fontSize: 18,
							fontWeight: 700,
							color: '#C80000',
							lineHeight: '24px'
						}}>
						{phone}
					</div>
					<div
						style={{
							display: 'flex',
							alignItems: 'center',
							marginTop: 12,
							justifyContent: 'center'
						}}>
						<div
							style={{
								fontSize: 12,
								fontWeight: 400,
								color: '#666666',
								marginRight: 12
							}}>
							{email}
						</div>
						<Button
							onClick={() => sendEmail()}
							type="primary"
							icon={<MailOutlined style={{ fontSize: 12 }} />}
							style={{ height: 24, width: 24 }}
						/>
					</div>
				</div>
			)}
			{isMobile && !showModalAvatar && (
				<div
					style={{ position: 'fixed', bottom: 30, right: 16 }}
					onClick={() => setShowModalAvatar(!showModalAvatar)}>
					<Avatar
						size={64}
						src={
							dataValues &&
							dataValues.analyst &&
							dataValues.analyst.avatar !== null &&
							dataValues.analyst.avatar.link
						}
						style={{
							border: '2px solid #262626',
							background: dataValues?.analyst?.avatar !== null ? '#FCFAF5' : undefined,
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'center',
							fontSize: 30
						}}>
						{dataValues?.analyst?.name ? dataValues?.analyst?.name[0].toUpperCase() : 'U'}
					</Avatar>
				</div>
			)}
			<Modal
				className="ModalAnalyst"
				width={328}
				style={{ heigth: 'auto' }}
				open={showModalAvatar}
				closable={false}
				centered
				maskClosable={true}
				footer={null}
				onCancel={() => setShowModalAvatar(!showModalAvatar)}>
				<div>
					<Row>
						<div
							style={{
								width: '100%',
								display: 'flex',
								justifyContent: 'space-between',
								alignItems: 'center'
							}}>
							<div
								style={{
									display: 'flex',
									flexDirection: 'column',
									justifyContent: 'space-between'
								}}>
								<Text
									style={{
										fontSize: '24px',
										fontWeight: 700,
										color: '#666666'
									}}>
									{t('typeMortgage.modalContactText1')}
								</Text>
								<Text
									style={{
										fontSize: 14,
										fontWeight: 400,
										color: '#666666',
										marginTop: 8
									}}>
									{t('typeMortgage.modalContactText2')}&nbsp;
									<b>{dataValues && dataValues?.analyst?.name}</b>,&nbsp;
									{t('contact.yourAnalyst')}.
								</Text>
							</div>
							<div style={{ width: 64, height: 64 }}>
								<Avatar
									size={64}
									src={
										dataValues &&
										dataValues.analyst &&
										dataValues.analyst.avatar !== null &&
										dataValues.analyst.avatar.link
									}
									style={{
										border: '2px solid #262626',
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'center',
										fontSize: 30
									}}>
									{dataValues?.analyst?.name ? dataValues?.analyst?.name[0].toUpperCase() : 'U'}
								</Avatar>
							</div>
						</div>
					</Row>
					<div style={{ display: 'flex', flexDirection: 'column' }}>
						{valuesDataAgent && (
							<Text
								style={{
									color: '#666666',
									fontSize: 14,
									fontWeight: 400,
									marginTop: 12
								}}>
								{t(`salesAgentExperience.${valuesDataAgent?.salesAgent}`)}
							</Text>
						)}
					</div>
					<Row>
						<hr
							color="#E5E5E5"
							size={1}
							border={'1px solid #E5E5E5'}
							style={{ width: '100%', marginTop: 16, marginBottom: 16 }}></hr>
					</Row>
					<div
						style={{
							display: 'flex',
							flexDirection: 'column'
						}}>
						<div
							style={{
								display: 'flex',
								justifyContent: 'space-between',
								alignItems: 'center',
								marginBottom: 10
							}}>
							<Text
								style={{
									fontSize: 16,
									fontWeight: 400,
									color: '#666666'
								}}>
								{dataValues && dataValues?.analyst?.phone
									? dataValues && dataValues?.analyst?.phone
									: 'No number'}
							</Text>
							<a
								href={`https://api.whatsapp.com/send?phone=%2B34${dataValues?.analyst?.phone
									.split(' ')
									.join('')}}`}
								target="_blank">
								<Button
									className="button-primary-engel"
									type="primary"
									icon={<WhatsAppOutlined style={{ fontSize: 13 }} />}
									style={{
										height: 24,
										width: 24,
										borderRadius: 2,
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'center'
									}}></Button>
							</a>
						</div>
						<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
							<Text
								style={{
									fontSize: 12,
									fontWeight: 400,
									color: '#666666'
								}}>
								{dataValues && dataValues?.analyst?.email}
							</Text>
							<a href={`mailto:${dataValues?.analyst?.email}`} target="_blank">
								<Button
									className="button-primary-engel"
									type="primary"
									icon={<MailOutlined style={{ fontSize: 13 }} />}
									style={{
										height: 24,
										width: 24,
										borderRadius: 2,
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'center'
									}}></Button>
							</a>
						</div>
					</div>
				</div>
				<div
					onClick={() => setShowModalAvatar(false)}
					style={{
						position: 'absolute',
						bottom: -80,
						right: 0,
						zIndex: 1000,
						background: 'white',
						height: 64,
						width: 64,
						borderRadius: '50%',
						border: '2px solid #262626',
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
						cursor: 'pointer',
						fontSize: 20
					}}>
					<DownOutlined style={{ color: '#262626' }} />
				</div>
			</Modal>
		</>
	);
};

export default AnalystInformation;
